import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '@/../environments/environment';
import { EmailConfig, EmailConfigRequest } from '@/models';
import { RsaEncryptionService } from './rsa-encryption.service';

@Injectable({
  providedIn: 'root',
})
export class EmailConfigService {
  private baseUrl = `${environment.apiUrl}/admin/email-config`;

  constructor(
    private http: HttpClient,
    private rsaEncryption: RsaEncryptionService
  ) {}

  getEmailConfig(): Observable<EmailConfig> {
    return this.http.get<EmailConfig>(this.baseUrl);
  }

  /**
   * Cria ou atualiza configuração de email
   * Criptografa os dados sensíveis antes de enviar
   */
  saveEmailConfig(email: string, appPassword: string): Observable<EmailConfig> {
    // Criptografar dados em paralelo
    return this.rsaEncryption.encryptMultiple([email, appPassword]).pipe(
      switchMap(([emailEncrypted, appPasswordEncrypted]) => {
        const request: EmailConfigRequest = {
          emailEncrypted,
          appPasswordEncrypted
        };

        return this.http.post<EmailConfig>(this.baseUrl, request);
      })
    );
  }

  /**
   * Obtém a chave pública RSA
   */
  getPublicKey(): Observable<any> {
    return this.http.get(`${this.baseUrl}/public-key`);
  }
}
